import React, { useRef, createContext, type RefObject, useState, useEffect, useContext } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";
import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";

import { useLocation } from "react-router-dom";

import Sidebar from '@rio-cloud/rio-uikit/Sidebar';

import SubNavigation from '@rio-cloud/rio-uikit/SubNavigation';
import { parseRoute } from "./routeHelper";
import { useRouteState } from "./routeHooks";
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import IframeResizer from "iframe-resizer-react";
import { config } from "../../config";
import { ApplicationLayoutBodyNavigation, AssetTree, Button, Tree } from "@rio-cloud/rio-uikit";
import TreeCategory from '@rio-cloud/rio-uikit/TreeCategory';
import { NotificationsContext } from "src/providers/NotificationProvider";
import NotificatioBar from "../NotificationBar";
import ChatMessages from "src/screens/chatMessages";
import SidebarVehicles from "../SidebarVehicles";
import { setGroupsFilter, setOpenSidebarDetail, setOpenVehicles, setVehiclesFilter, useAppSelector } from "@store";
import { useDispatch } from "react-redux";
import VehicleDetails from "../VehicleDetails";
import { useResizer } from "@hooks";
import CustomAssetTree from "./MenuTree";
import { setPackageRole, usePackageRole, usePackageRoleLoaded } from "src/store/packages/packagesSlice";
import { fetchPackageGroupMe } from "src/services/packages";

const RouteUpdater = () => {
  const { search } = useLocation();
  useRouteState(() => {
    parseRoute(search);
  });

  return null;
};

// Componentes específicos para o ROUTING
const RoutingMapItems = [{
  key: "map",
  route: <NavLink to="/routing/map/trips">Viagens em andamento</NavLink>,
},
{
  key: "map",
  route: <NavLink to="/routing/map/fleets">Posição atual dos veículos</NavLink>,
}];

const BaseNavItems = [
  {
    key: "routes",
    route: <NavLink to="/routing/routes">Rotas</NavLink>,
  },
  {
    key: "trips",
    route: <NavLink to="/routing/trips">Viagens</NavLink>,
  },
  {
    key: "map",
    route: <NavLink to="/routing/map/trips">Monitoramento</NavLink>,
  },
  {
    key: "performance",
    route: <NavLink to="/routing/performance/list">Desempenho</NavLink>,
  },
  {
    key: "points",
    route: <NavLink to="/routing/points">Score</NavLink>,
  },
  {
    key: "areas",
    route: <NavLink to="/routing/zone">Áreas</NavLink>,
  },
  {
    key: "interestPoints",
    route: <NavLink to="/routing/interest-points">PDI</NavLink>,
  },
];

const PackageNavItem = {
  key: "package",
  route: <NavLink to="/routing/package">Pacotes</NavLink>,
};

const RoutingHeader = () => {
  const ContextNotification = useContext(NotificationsContext);
  const dispatch = useDispatch();
  const packageRole = usePackageRole();
  const packageRoleLoaded = usePackageRoleLoaded();

  useEffect(() => {
    if (!packageRoleLoaded) {
      fetchPackageGroupMe()
        .then((response) => {
          const { role, dealershipGroupIds } = response.data.result;
          dispatch(setPackageRole({ role, dealershipGroupIds }));
        })
        .catch(() => {
          dispatch(setPackageRole({ role: null, dealershipGroupIds: [] }));
        });
    }
  }, [packageRoleLoaded, dispatch]);

  const navItems = packageRole
    ? [...BaseNavItems, PackageNavItem]
    : BaseNavItems;

  const notifications = (
    <NotificatioBar
      href="/routing/notifications"
      total={ContextNotification.total}
      notifications={ContextNotification.today.length > 0 ? ContextNotification.today : ContextNotification.notifications}
    />
  );

  const userMenuItem = (
    <DefaultUserMenu
      environment={
        process.env.NODE_ENV === "development" ? "development" : "production"
      }
    />
  );

  return (
    <ApplicationHeader
      appNavigator={
        <IframeResizer
          className="iFrameResizer"
          src={config.backend.MENU_SERVICE}
        />
      }
      homeRoute={<Link to={config.homeRoute || ""} />}
      appMenuItems={RoutingMapItems}
      label="RIO AI Route"
      navItems={navItems}
      actionBarItems={[
        notifications,
        userMenuItem,
      ]}
    />
  );
};

const RoutingMenuSubItems = () => {
  const items = {
    map: RoutingMapItems,
  };

  const location = useLocation();

  return (
    <ApplicationLayoutBodyNavigation className={'margin-0 padding-0'}>
      <SubNavigation className="padding-0 margin-0" navItems={location?.pathname.includes('/routing/map') ? items.map : []} />
    </ApplicationLayoutBodyNavigation>
  );
};

type AppContextType = { sidebarRef: RefObject<HTMLDivElement> | null };
const AppContext = createContext<AppContextType>({ sidebarRef: null });
const CATEGORY_ASSETS = 'trucks';
const CATEGORY_MESSAGES = 'messages';

// Layout específico para ROUTING
const RoutingLayout = () => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const {openVehicles} = useAppSelector(state => state.fleet)
  const dispatch = useDispatch();
  const [selected, setSelected] = useState('');
  const location = useLocation();

  useEffect(() => {
    handleClickItem(CATEGORY_ASSETS);
  }, []);

  const handleClickItem = (category: string) => {
    if (selected === category) {
      setSelected('');
    } else {
      setSelected(category);
    }
  };

  const handleToogleVehicles = () => {
    dispatch(setOpenVehicles(false));
  }

 
  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout data-testid="app-layout">
        <ApplicationLayout.Header>
          <RoutingHeader />
        </ApplicationLayout.Header>

        <ApplicationLayout.Sidebar className="left">
          {/* <CustomAssetTree /> */}
          <Sidebar
            closed={false}
            width={50}
            onClose={undefined}
            disableClose
            disableEsc
            showHeaderBorder={false}
            headerButtons={null}
            headerClassName="display-none"
            className="bg-black padding-top-15 padding-bottom-15"            
          >
            <div className="display-flex flex-column align-items-center justify-content-between height-100pct overflow-hidden">
              <div>
                {location.pathname === '/routing/map/fleets' ? (
                  <div className="position-relative">
                    <Button
                      iconOnly
                      iconName="rioglyph rioglyph-truck"
                      bsSize="lg"
                      className="bg-black border-none"
                      onClick={handleToogleVehicles}
                    />
                    <span
                      className="rioglyph rioglyph rioglyph-play text-color-white"
                      style={{
                        position: "absolute",
                        zIndex: 1000,
                        right: -5, 
                        top: "40%",
                        transform: "translateY(-30%) rotate(180deg)",
                        fontSize: 15,
                        border: "none",
                        backgroundColor: "transparent",
                      }}
                    />
                  </div>
                ) : null}
              </div>

              <div className="display-flex flex-column align-items-center gap-10">
                <Button
                  iconOnly
                  iconName="rioglyph rioglyph-chat"
                  bsSize="lg"
                  className="bg-black border-none"
                  onClick={() => handleClickItem(CATEGORY_MESSAGES)}
                />
                <Button
                  iconOnly
                  iconName={selected !== '' ? "rioglyph rioglyph-chevron-left" : "rioglyph rioglyph-chevron-right"}
                  bsSize="lg"
                  className="bg-black border-none"
                  onClick={() => setSelected('')}
                />
              </div>
            </div>
          </Sidebar>
        </ApplicationLayout.Sidebar>

        <ApplicationLayout.Sidebar className="right">
          <Sidebar
            closed={selected !== CATEGORY_MESSAGES}
            width={350}
            onClose={undefined}
            disableClose
            disableEsc
            showHeaderBorder={false}
            headerClassName="display-none"
          >
            <ChatMessages />
          </Sidebar>
        </ApplicationLayout.Sidebar>

        <ApplicationLayout.Sidebar className="right" ref={sidebarRef} />

        <ApplicationLayout.Body innerClassName="padding-0" className="padding-0 margin-0" navigation={<RoutingMenuSubItems />}>
          <Outlet />
          <RouteUpdater />
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default RoutingLayout; 